import Vuex from "vuex"

import storeConfig from "@/store_config"

export default new Vuex.Store(storeConfig)
